import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchBlogAuthors() {
  return function withContext(context) {
    const url = `${API_URL}blog/authors`;
    return _fetch(url, { withAuth: false }, { method: 'GET' })(context);
  };
}
